import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "娱乐新闻", to: "/category/entertainment" },
      { label: "社会热点", to: "/category/society" },
      { label: "网络趣闻", to: "/category/netfun" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "联系方式", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-newspaper-line text-xl"></i>
              </span>
              <span className="font-heading font-black text-lg text-foreground-950">
                51吃瓜官网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              51吃瓜官网致力于为关注娱乐圈动态、社会热门事件与网络热点的广大网民，提供实时、权威且生动的资讯内容。本站为资讯娱乐演示站点，内容仅供浏览参考。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950 mb-3">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 51吃瓜官网 · 保留所有权利 · 备案号：演示备案 00000000 号
          </p>
          <p className="text-xs text-foreground-500">
            联系邮箱：hello@51chigua.demo
          </p>
        </div>
      </div>
    </footer>
  );
}